import React from 'react';

export default function WithLoading(Component) {
  const { isLoading } = Component.props;
  
  if (!isLoading) {
    return Component;
  }

  return (
    <div className="row">
      <div className="col-sm-6 col-sm-offset-3">
        <h4 className="text-center">Loading...</h4>
        <div className="progress">
          <div className="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style={{width: "100%"}}>
            <span className="sr-only">Loading</span>
          </div>
        </div>
      </div>
    </div>
  );
}
